import { URLConfig } from "../network";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { IApplicationAllResponse } from "../models";

export const getApplications = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<IApplicationAllResponse> => {
  let url = URLConfig.getApplicationURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        const res = response as unknown as IApplicationAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getApplicationsNextPage = (
  nextPageURI: string
): Observable<IApplicationAllResponse> => {
  const url = URLConfig.getApplicationNextPageURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        const res = response as unknown as IApplicationAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const addApplication = (
  payload: any
): Observable<IApplicationAllResponse> => {
  const url = URLConfig.getApplicationURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (response) => {
        const res = response as unknown as IApplicationAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};
export const updateApplication = (
  payload: any
): Observable<IApplicationAllResponse> => {
  const url = URLConfig.getApplicationURL();
  return new Observable((subscriber) => {
    NetworkService.put(url, payload).then(
      (response) => {
        const res = response as unknown as IApplicationAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getContentLengthForApplication = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getApplicationURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};
